import React from 'react';
import getLocaleMessages from '../../../../utils/localesMessages';
import { Checkbox } from '@paypalcorp/pp-react-checkbox';

const { rp: { recurring_label } = {} } = getLocaleMessages(
  'buttonsV3/recurringCheckbox'
);

const RecurringCheckbox = () => {
  return (
    <Checkbox
      className="recurring-checkbox"
      label={recurring_label}
      name="recurringCheckbox"
      id="recurringCheckbox"
      disabled={true}
    />
  );
};

export default RecurringCheckbox;
